
import parse from "html-react-parser";
import { FaPlus, FaMinus } from "react-icons/fa";

const FaqItem = ({ faq, index, showAnswer, toggleAnswer }) => {

  return (
    <div className="faq-item" onClick={() => toggleAnswer(index)}>
      <div className="question">
        <p>{faq?.question}</p>
        <button
          className="faq-btn"
          aria-label={showAnswer === index ? "Hide answer" : "Show answer"}
        >
          {showAnswer === index ? <FaMinus /> : <FaPlus />}
        </button>
      </div>
      <div className={`answer-info ${showAnswer === index ? "show" : ""}`}>
        {showAnswer === index && (
          <p style={{ borderBottom: "1px solid #e3e3e3" }}>
            {parse(`${faq.answer}`)}
          </p>
        )}
      </div>
    </div>
  );
};

export default FaqItem;
